export const getParams = (data) => {
  const params = {};
  Object.keys(data).forEach((key) => {
    if (key === 'param' && data.param) {
      params[data.param] = data.val;
    } else if (key === 'enrolmentStatus' && data[key]) {
      if (data[key] === 'Basic info only') {
        params.dropOuts = 'basicInfo';
      } else if (data[key] === 'Payment details only') {
        params.dropOuts = 'paymentInfo';
      } else if (data[key] === 'Enrolled') {
        params.enrolled = 1;
      } else if (data[key] === 'Completed all payment') {
        params.paymentStatus = 1;
      }
    } else if (key === 'startDate' && data[key]) {
      // return date in UTC
      params.startDate = new Date(
        new Date(data[key]).setUTCHours(24, 0, 0, 0)
      ).toISOString();
      if (!data.endDate) {
        params.endDate = new Date(
          new Date().setUTCHours(24, 0, 0, 0)
        ).toISOString();
      }
    } else if (key === 'endDate' && data[key]) {
      params.endDate = new Date(
        new Date(data[key]).setUTCHours(24, 0, 0, 0)
      ).toISOString();
    } else if (key === 'createdAt' && data[key]) {
      params.createdAt = new Date(
        new Date(data[key]).setUTCHours(24, 0, 0, 0)
      ).toISOString();
    } else if (key === 'classCode') {
      params.classCode = data[key].join();
    } else if (key === 'coursesAllowed' && data[key]) {
      params[key] = data[key].join();
    } else if (key === 'courseOffersAllowed' && data[key]) {
      params[key] = data[key].join();
    } else if (
      key !== 'param' &&
      key !== 'val' &&
      data[key] &&
      data[key] !== ''
    ) {
      params[key] = data[key];
    }
  });
  return params;
};
